/**
 * Shared chip styling and schedule ordering for the admin dashboard panels.
 *
 * `STATUS_STYLE` was previously inlined in CoursePlansList; it is lifted here so the delivery
 * panel and the plans list cannot drift apart on what "Active" looks like.
 */

export const STATUS_STYLE = {
  active:    { label: "Active",    bg: "#dcfce7", fg: "#166534" },
  upcoming:  { label: "Upcoming",  bg: "#dbeafe", fg: "#1d4ed8" },
  completed: { label: "Completed", bg: "#e5e7eb", fg: "#374151" },
  archived:  { label: "Archived",  bg: "#e5e7eb", fg: "#374151" },
};

export const statusStyleFor = (status) =>
  STATUS_STYLE[String(status || "").toLowerCase()] || STATUS_STYLE.completed;

/** Delivery is still expected for these; a missing tutor on a completed group is not a problem. */
export const LIVE_STATUSES = ["active", "upcoming"];

export const isLiveStatus = (status) =>
  LIVE_STATUSES.includes(String(status || "").toLowerCase());
